// @flow

import ApiMetricsError from './ApiMetricsError';
import { API_METRICS_NAME, API_END_POINTS } from './apiMetricsConstants';
import trovitAPI from '../api';
import clientConfig from '../../../parameters/client/config';

const baseUrl = clientConfig.metricsApi;
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const ApiMetrics = Object.create(trovitAPI);
ApiMetrics.apiName = API_METRICS_NAME;
ApiMetrics.ApiServiceError = ApiMetricsError;

ApiMetrics.incrementQuery = body =>
  trovitAPI.trovitFetch(`${baseUrl}${API_END_POINTS.INCREMENT_QUERY}`, 'POST', body, {
    headers,
  });

ApiMetrics.incrementTimeout = body =>
  trovitAPI.trovitFetch(`${baseUrl}${API_END_POINTS.INCREMENT_TIMEOUT}`, 'POST', body, {
    headers,
  });

ApiMetrics.incrementError = body =>
  trovitAPI.trovitFetch(`${baseUrl}${API_END_POINTS.INCREMENT_ERROR}`, 'POST', body, {
    headers,
  });

ApiMetrics.storeResponseTime = body =>
  trovitAPI.trovitFetch(`${baseUrl}${API_END_POINTS.STORE_RESPONSE_TIME}`, 'POST', body, {
    headers,
  });

ApiMetrics.incrementQueryCustom = (url = baseUrl, body) =>
  trovitAPI.trovitFetch(`${url}${API_END_POINTS.INCREMENT_QUERY_CUSTOM}`, 'POST', body, {
    headers,
  });

export default ApiMetrics;



// WEBPACK FOOTER //
// ./app/sdk/metrics/Api.js